import { LeftArrowWhite } from "src/assets/images/svg/LeftArrow";
import { Button } from "src/components/ui/Button";

const PaymentSummaryCard = ({ amountLabel, formattedAmount, currency }) => {
  if (!formattedAmount) {
    return null;
  }

  const currencyCode = currency ? String(currency).toUpperCase() : null;

  return (
    <div className="flow-form-preview-panel mt-6 w-full rounded-[var(--flow-radius-lg)] px-4 py-3.5">
      <div className="flex items-end justify-between gap-3">
        <div className="min-w-0 text-left">
          <p className="text-xs font-medium uppercase tracking-wide text-flow-muted">
            {amountLabel}
          </p>
          <p className="mt-1 text-lg font-semibold leading-tight text-[color:color-mix(in_srgb,var(--flow-success)_78%,white)]">
            {formattedAmount}
          </p>
        </div>
        {currencyCode && (
          <span className="shrink-0 text-xs font-medium uppercase tracking-wide text-flow-muted">
            {currencyCode}
          </span>
        )}
      </div>
    </div>
  );
};

const PaymentOverview = ({
  currency,
  formattedAmount,
  instruction,
  onBack,
  t,
}) => (
  <>
    <div className="text-left">
      <Button variant="primaryBack" onClick={onBack} aria-label={t("actions.back")}>
        <LeftArrowWhite />
      </Button>
    </div>

    <div className="mt-10 grid w-full gap-3 text-left">
      <h1 className="text-h5 font-bold text-flow-heading">
        {t("paymentVerification.title")}
      </h1>
      <p className="text-body text-Gray900">{instruction}</p>
    </div>

    <PaymentSummaryCard
      amountLabel={t("paymentVerification.amount")}
      currency={currency}
      formattedAmount={formattedAmount}
    />
  </>
);

export default PaymentOverview;
